import axios, { AxiosResponse } from 'axios';
import { ChatMessage } from '../types/chat';

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/v1/chat`;

export async function addChatMessage(chatMessage: ChatMessage): Promise<AxiosResponse<ChatMessage[]>> {
    return await axios.post(`${API_BASE_URL}`, chatMessage);
}